import React, { useEffect, useRef, useState } from "react";
import { IPetsyBonusTrackerProps } from "./PetsyBonusTracker.types";
import { getPetAge } from "../../KnoseAPI/Lib/Utils";
import "./PetsyBonusTracker.scss";
import PetsyAnnualLimitBonusAppliedPopup from "../PetsyAnnualLimitBonusAppliedPopup";
import PetsyCanvasConfetti from "../PetsyCanvasConfetti";
import {
  useFlowData,
} from "@adaptis/flow-components";
import moment from 'dayjs';
import customParseFormat from'dayjs/plugin/customParseFormat';
moment.extend(customParseFormat);

export default function PetsyBonusTracker(props: IPetsyBonusTrackerProps) {
  const { getData, setData, injectData } = useFlowData();
  const [isShowAnnualLimitPopup, setIsShowAnnualLimitPopup] = useState(false);
  const [countRunEffect, setCountRunEffect] = useState(0);
  const petType = getData("petType");
  const petAgeCategory = getData("petAgeCategory");
  const isShowedPopup = getData("isShowedPopup");

  function OnCloseAnnualLimitCallback() {
    setIsShowAnnualLimitPopup(false);
    setCountRunEffect(current => current + 1);
  }

  useEffect(() => {    
    if (petAgeCategory && !isShowedPopup) {
      setIsShowAnnualLimitPopup(true);  
      setData("isShowedPopup", true);
    }

  }, []);

  return (
    <>
      <PetsyAnnualLimitBonusAppliedPopup show={isShowAnnualLimitPopup} pettype={petType} petagecategory={petAgeCategory} onClose={OnCloseAnnualLimitCallback} className="" />
      {/* {<PetsyCanvasConfetti run={countRunEffect} />} */}
    </>
  );
}
